import { Routes } from '@angular/router';
import { AppBoxedRegisterComponent } from './boxed-register/boxed-register.component';
import { AppSideLoginComponent } from './side-login/side-login.component';
import { SuccessRegisterComponent } from './boxed-register/components/success-register/success-register.component';
import { ProcessDataComponent } from './process-data/process-data.component';
import { ChangePasswordComponent } from './side-login/modal/change-password/change-password.component';

export const AuthenticationRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'register',
        component: AppBoxedRegisterComponent,
      },
      {
        path: 'register/:id',
        component: AppBoxedRegisterComponent,
      },
      {
        path: 'login',
        component: AppSideLoginComponent,
      },
      {
        path: 'change-pass',
        component: ChangePasswordComponent,
      },

      {
        path: 'success-register',
        component: SuccessRegisterComponent,
      },
      {
        path: 'procces-data',
        component: ProcessDataComponent,
      },
    ],
  },
];
